// test2402
(2402 && 0);
